import React from 'react';
import PropTypes from 'prop-types';
import { useReactTable, getCoreRowModel } from '../../../Utils/ReactTable';
import styled from 'styled-components';
import { DataTable, DataTableDownloadReport, DataTableHeader } from '../../DataTable/DataTable';
import PeriodInfo from './PeriodInfo';
import Table from '../../Table/Table';
import Pagination from '../../Table/Pagination';

export const StyledPeriodContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #18223d;
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 18.2px */
  letter-spacing: 0.28px;

  @media (max-width: 1280px) {
    display: flex;
    flex-direction: column;
  }
`;

const ReportPeriodTable = ({
  data = [],
  columns,
  scheduleName = '',
  options = {},
}) => {
  const defaultOptions = {
    onChangePageSize: () => null,
    onChangePage: () => null,
    onCleanFilter: () => null,
    onDownloadReport: () => null,
    totalElements: 0,
    totalPages: 1,
    currentPage: 1,
    ...options,
  };

  const handleChangePageSize = pageSize => {
    defaultOptions.onChangePageSize(pageSize);
  };

  const handleChangePage = page => {
    defaultOptions.onChangePage(page);
  };

  const handleOnCleanFilters = () => {
    defaultOptions.onCleanFilter();
  };

  const handleOnDownloadReport = () => {
    defaultOptions.onDownloadReport();
  };

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    defaultColumn: {
      size: 100, //starting column size
    },
  });

  return (
    <DataTable >
      <DataTableHeader>
        <StyledPeriodContent>
          <PeriodInfo
            noResults={defaultOptions.totalElements}
            shedule={scheduleName}
          />
        </StyledPeriodContent>
        <DataTableDownloadReport
          reportName='Descargar reporte'
          onDownloadReport={handleOnDownloadReport}
        />
      </DataTableHeader>
      <div>
        <Table
          table={table}
          sticky='order_id'
          onCleanFilter={handleOnCleanFilters}
          columSize='px'
        />
      </div>
      <Pagination
        onChangePageSize={handleChangePageSize}
        onChangePage={handleChangePage}
        className='pagination-section'
        options={{
          totalElements: defaultOptions.totalElements,
          totalPages: defaultOptions.totalPages,
          currentPage: defaultOptions.currentPage,
        }}
      />
    </DataTable>
  );
};

ReportPeriodTable.propTypes = {
  periodInfo: PropTypes.any,
  data: PropTypes.array,
  scheduleName: PropTypes.string,
  columns: PropTypes.any,
  options: PropTypes.shape({
    onCleanFilter: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onChangePage: PropTypes.func,
    totalElements: PropTypes.number,
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
  }),
};

export default ReportPeriodTable;
